(() => {
  if (customElements.get('rok-flooring-calculator')) return;
  class FlooringCalculator extends HTMLElement {
    connectedCallback() {
      this.area = this.querySelector('[data-area]');
      this.waste = this.querySelector('[data-waste]');
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en-US', {style:'currency', currency:this.dataset.currency || 'USD'});
      this.number = new Intl.NumberFormat(this.dataset.locale || 'en-US', {maximumFractionDigits:2});
      this.onInput = () => this.update();
      this.addEventListener('input', this.onInput);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          const html = event?.data?.html;
          const next = html?.querySelector?.('rok-flooring-calculator');
          if (next) { this.dataset.price = next.dataset.price; this.dataset.coverage = next.dataset.coverage; this.dataset.unitPrice = next.dataset.unitPrice; this.update(); }
        });
      }
      this.update();
    }
    disconnectedCallback() { this.removeEventListener('input',this.onInput); this.unsubscribe?.(); }
    update() {
      const area = Number(this.area.value), coverage = Number(this.dataset.coverage), price = Number(this.dataset.price);
      const write = (key,value) => { const element = this.querySelector(`[data-${key}]`); if (element) element.textContent=value; };
      write('box-price',this.money.format(price/100));
      write('unit-price',this.money.format(Number(this.dataset.unitPrice)));
      if (!Number.isFinite(area) || area<=0 || !this.area.validity.valid || !(coverage>0) || !Number.isFinite(price)) {
        for (const key of ['boxes','total-coverage','floor-total','rolls','barrier-total','combined-total']) write(key,'—');
        return;
      }
      const requested = area*(this.waste.checked?1.1:1);
      const boxes = Math.ceil(Number((requested/coverage).toFixed(10)));
      const rollCoverage = Number(this.dataset.rollCoverage);
      const rolls = rollCoverage > 0 ? Math.ceil(Number((requested/rollCoverage).toFixed(10))) : 0;
      const floorTotal = boxes*price, barrierTotal=rolls*Number(this.dataset.rollPrice);
      write('boxes',this.number.format(boxes));
      write('total-coverage',this.number.format(boxes*coverage));
      write('floor-total',this.money.format(floorTotal/100));
      write('rolls',this.number.format(rolls));
      write('barrier-total',this.money.format(barrierTotal/100));
      write('combined-total',this.money.format((floorTotal+barrierTotal)/100));
    }
  }
  customElements.define('rok-flooring-calculator',FlooringCalculator);
})();
